import { Link } from "react-router-dom";
import { IconInfoCircle } from "@tabler/icons-react";
// @ts-expect-error pure js
import TextInput from "../../UI/TextInput";
import AddressFields from "../../UI/AddressFields";
// @ts-expect-error pure js
import { ReactSelect } from "../../UI/Select";
import Tooltip from "../../UI/Tooltip";
import Text from "../../UI/Text";
// @ts-expect-error pure js
import useProfileBailleurs from "../../../hooks/use-profile-bailleurs";
import PropertyPhotoManager from "../PropertyPhotoManager";
import styles from "./HeaderPropertyForm.module.css";

interface HeaderPropertyFormProps {
  isFolder?: boolean;
  propertyId?: number;
}

export default function HeaderPropertyForm({
  isFolder,
  propertyId,
}: HeaderPropertyFormProps) {
  const { profileBailleurs } = useProfileBailleurs();
  const selectOptions =
    profileBailleurs
      ?.filter(
        (profile: { profiles: unknown[]; nom_profile: string; id: number }) =>
          profile.profiles.length !== 0,
      )
      .map(
        (profile: {
          profiles: unknown[];
          nom_profile: string;
          id: number;
        }) => ({
          label: profile.nom_profile,
          value: profile.id,
        }),
      ) ?? [];

  return (
    <div className={styles.fields}>
      <TextInput
        type="text"
        name="nom"
        placeholder="Coloc Jeanne d'Arc"
        label={`Nom du ${isFolder ? "dossier" : "bien"}`}
        mandatory
        marginForm=""
      />

      <div>
        <ReactSelect
          name="id_profile_nom_owner"
          label="Profil bailleur à affecter"
          placeholder="SCI Dupont"
          mandatory
          options={selectOptions}
          marginForm=""
        />

        <Text variant="deci">
          Si votre profil n'apparaît pas, vous pouvez le créer dans la rubrique
          <Link to="/bailleur/profiles"> Profils bailleur</Link>
        </Text>
      </div>

      <AddressFields nameRue="rue" mandatory={!isFolder} />

      {propertyId && (
        <PropertyPhotoManager propertyId={propertyId} isFolder={isFolder} />
      )}

      {isFolder && (
        <>
          <TextInput
            type="number"
            name="surface_total"
            label={
              <>
                Surface totale{" "}
                <Tooltip
                  content={
                    <Text>
                      Utile pour les calculs de répartition des opérations
                      comptables au prorata de la surface. <br />
                      En particulier si le dossier représente un logement en
                      colocation individuelle, chaque chambre étant un bien dans
                      le dossier. <br />
                      Dans ce cas la surface à renseigner est la somme des
                      surfaces des chambres plus les parties communes.
                    </Text>
                  }
                >
                  <IconInfoCircle size={16} />
                </Tooltip>
              </>
            }
            placeholder="45"
            step="0.01"
            unit="m²"
            className={styles.grow}
            marginForm=""
          />
          <TextInput
            type="date"
            name="date_achat"
            label={
              <>
                Date d'achat{" "}
                <Tooltip
                  content={
                    <Text>
                      Nécessaire si vous prenez la comptabilité chez Qalimo. Ne
                      mettez une date d'achat sur le dossier que si vous
                      possédez tout l'immeuble. Si ce n'est pas le cas, mettez
                      une date sur chacun des appartements qui le compose.
                    </Text>
                  }
                >
                  <IconInfoCircle size={16} />
                </Tooltip>
              </>
            }
            className={styles.grow}
            marginForm=""
          />
          <TextInput
            type="number"
            name="prix_achat"
            placeholder="100000"
            label={
              <>
                Prix d'achat{" "}
                <Tooltip
                  content={
                    <Text>
                      Nécessaire si vous prenez la comptabilité chez Qalimo. Ne
                      mettez un prix sur le dossier que si vous possédez tout
                      l'immeuble. Si ce n'est pas le cas, mettez un prix sur
                      chacun des appartements qui le compose.
                    </Text>
                  }
                >
                  <IconInfoCircle size={16} />
                </Tooltip>
              </>
            }
            unit="€"
            className={styles.grow}
            marginForm=""
          />
        </>
      )}
    </div>
  );
}
